import { gql } from "@apollo/client";
import { IWishlistQueryResponse } from "@interfaces/wishlist.types";
import client from "@services/apolloClient";

/** 1. Model Details **/
export const FIND_MODEL_DETAILS = gql`
  query FindModelDetails($slug: String!, $cityName: String!) {
    findModelDetails(slug: $slug, cityName: $cityName) {
      brand {
        name
      }
      model {
        name
      }
      minPrice
      maxPrice
      distinctColors {
        id
        hexCodes
        colorType
      }
      minMileage {
        value
        unit
      }
      maxMileage {
        value
        unit
      }
      engineCapacities
      transmissionTypes
      fuelTypes
      seatingCapacity
      minAckodriveSavings
    }
  }
`;

export async function fetchWishlistModelDetails(
  slug: string,
  cityName: string
): Promise<IWishlistQueryResponse> {
  try {
    const { data } = await client.query({
      query: FIND_MODEL_DETAILS,
      variables: { slug, cityName },
    });
    return data?.findModelDetails ?? null;
  } catch (error: any) {
    console.error("Error fetching model details:", error?.message);
    return {} as IWishlistQueryResponse;
  }
}
